import React, { useEffect, useState } from 'react'
import useHttp from '../../../hooks/use-http';
import Input from "../../UI/Input";
import { endPoints } from "../../../config/end-points"
import { cuteToast } from '../../UI/cute';
import { useDispatch } from 'react-redux';
import { settingAction } from "../../../store/setting-store";

const Smtp = () => {

    const {sendRequest: insertSMTPDetails} = useHttp();
    const {sendRequest: getSettingData} = useHttp();
    const dispatch = useDispatch();

    const [details, setDetails] = useState({
        senderName: "",
        senderEmail: "",
        smtpHost: "",
        smtpUsername: "",
        smtpPort: "",
    });

    useEffect(()=>{
        // console.log('here setting')
        getSettingData({
            url: endPoints.getSettingData,
            method: "GET",
        },(response)=>{
            // console.log(response)
            if(response.status === 200 && response.body.length > 0){
                // console.log(response.body)
                const result = response.body
                const smtpData = result.filter((data)=>data.meta_type === "smtp_details");
                const meta_data = JSON.parse(smtpData[0].meta_data)
                if(meta_data){
                    setDetails(meta_data)
                    dispatch(settingAction.setSMTPDetails({ smtp_details:meta_data}));
                }
            }
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const formHandler = (event) => {
        event.preventDefault();
        dispatch(settingAction.setSMTPDetails({ smtp_details:details}));

        insertSMTPDetails({
            url: endPoints.updateSmtpDetails,
            method: "POST",
            body: {
                ...details,
                type:"smtp_details"
            },
        },(response)=>{
            if(response.status === 200){
                cuteToast({
                    type: "success",
                    message: "Saved Successfully.",
                    timer: 5000,
                    title: "SMTP Settings",
                  });
            }
        })
    }
    
  return (
    <div className="col-md-12 mb-4">
        <div className="bx_a">
            <form onSubmit={formHandler}>
                <h5 className="mb-4 pb-3 small_title d-flex">
                    SMTP Settings
                </h5>
                <h6 className="small_title d-flex">
                    Sender Details:
                </h6>
                <div className="form-row row">
                    <div className="form-group col-md-6">
                        <label htmlFor="inputName" className='h6'>Sender Name *:</label>
                        <Input
                            type="text"
                            inputClass="form-control"
                            value={details.senderName}
                            id="inputName"
                            placeholder="Enter Your Name..."
                            onChange={(e) =>
                                setDetails({ ...details, senderName: e.target.value })
                            }
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="inputEmail4" className='h6'>Sender Email *:</label>
                        <Input
                            type="text"
                            inputClass="form-control"
                            value={details.senderEmail}
                            id="inputEmail4"
                            placeholder="Enter Your Email..."
                            onChange={(e) =>
                                setDetails({ ...details, senderEmail: e.target.value })
                            }
                        />
                    </div>  
                </div>
                <h6 className="small_title d-flex">
                    SMTP Details:
                </h6>
                <div className="form-row row">
                    <div className="form-group col-md-4">
                        <label htmlFor="inputHName" className='h6'>Host Name *:</label>
                        <Input
                            type="text"
                            inputClass="form-control"
                            value={details.smtpHost}
                            id="inputHName"
                            placeholder="Enter SMTP Host Name Here"
                            onChange={(e) =>
                                setDetails({ ...details, smtpHost: e.target.value })
                            }
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label htmlFor="inputUEmail4" className='h6'>Username *:</label>
                        <Input
                            type="text"
                            inputClass="form-control"
                            value={details.smtpUsername}
                            id="inputUEmail4"
                            placeholder="Enter SMTP Username Here"
                            onChange={(e) =>
                                setDetails({ ...details, smtpUsername: e.target.value })
                            }
                        />
                        
                    </div>  
                    <div className="form-group col-md-4">
                        <label htmlFor="inputPort" className='h6'>Port *:</label>
                        <Input
                            type="number"
                            inputClass="form-control"
                            value={details.smtpPort}
                            id="inputPort"
                            placeholder="Enter Your SMTP Port Here"
                            onChange={(e) =>
                                setDetails({ ...details, smtpPort: e.target.value })
                            }
                        />
                    </div>
                </div>
            
                <div className="form-group d-flex justify-content-end">
                    <button className='btn mt-4 w-25' type='submit'>Save Details</button>
                </div>  
            </form>
        </div>
    </div>
  )
}

export default Smtp